import { render, staticRenderFns } from "./myPatient.vue?vue&type=template&id=517aae50&scoped=true&"
import script from "./myPatient.vue?vue&type=script&lang=js&"
export * from "./myPatient.vue?vue&type=script&lang=js&"
import style0 from "./myPatient.vue?vue&type=style&index=0&id=517aae50&rel=stylesheet%2Fless&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517aae50",
  null
  
)

export default component.exports